/* ---------------------------------------------------------------
   Хоризонтален продуктов релс: стрелки + индикатор за прогрес.
   В макета този код живееше в shell.js, който не се пренася в темата
   (там хедърът и футърът са Liquid секции). Затова е изваден тук.
   Работи прогресивно: ако няма .hrail-wrap, мълчи.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var CHEV_L = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function build(rail) {
    var wrap = rail.closest('.hrail-wrap');
    if (!wrap || wrap.dataset.railReady) return;
    wrap.dataset.railReady = '1';

    wrap.insertAdjacentHTML(
      'beforeend',
      '<button type="button" class="hnav prev" aria-label="Назад">' + CHEV_L + '</button>' +
      '<button type="button" class="hnav next" aria-label="Напред">' + CHEV_R + '</button>'
    );

    var bar = document.createElement('div');
    bar.className = 'hbar';
    bar.innerHTML = '<i></i>';
    wrap.after(bar);

    var prev = wrap.querySelector('.hnav.prev');
    var next = wrap.querySelector('.hnav.next');
    var ind  = bar.querySelector('i');

    function step() { return rail.clientWidth * 0.8; }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left:  step(), behavior: 'smooth' }); });

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var scrollable = max > 4;
      prev.disabled = !scrollable || rail.scrollLeft < 8;
      next.disabled = !scrollable || rail.scrollLeft > max - 8;
      bar.style.display = scrollable ? '' : 'none';
      if (!scrollable) return;
      var vis = rail.clientWidth / rail.scrollWidth;
      ind.style.width = (vis * 100) + '%';
      ind.style.left  = (rail.scrollLeft / max * (100 - vis * 100)) + '%';
    }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    // картите може да дойдат след първия рендер (Section Rendering / lazy)
    new MutationObserver(sync).observe(rail, { childList: true });
  }

  function scan() {
    var rails = document.querySelectorAll('.hrail');
    for (var i = 0; i < rails.length; i++) build(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  // Theme Editor пре-рендира секции без презареждане
  document.addEventListener('shopify:section:load', scan);
  window.NexumRail = { scan: scan };
})();
